import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import { Link } from "react-router-dom";
import { Users, Star, Heart } from "lucide-react";

const SuccessStoriesPage = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStories = async () => {
      try {
        const res = await axios.get("/api/success-stories-view/");
        setStories(res.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchStories();
  }, []);

  return (
    <div className="max-w-7xl  mx-auto ">
      {/* Success Story header with green underline */}
      <div className="border-b border-gray-300 mb-4 flex items-baseline gap-4">
        <a
          href="success-story"
          className="text-lg md:text-xl font-semibold text-green-600 relative pb-1 text-decoration-none"
        >
          Success Story
        </a>
        <a
          href="upload-success-story"
          target=""
          className="text-md md:text-lg text-gray-800 hover:text-green-600 text-decoration-none"
        >
          Post your Success Story
        </a>
      </div>

      {/* Header Banner Section */}
      <div className="bg-gray-100 rounded-lg overflow-hidden mb-8 relative">
        <img
          src={require("../../assets/wed.jpg")}
          alt="Millions of Happy Marriages"
          className="w-full h-64 object-cover opacity-80"
        />
        <h1 className="absolute inset-0 flex items-center justify-center text-3xl md:text-5xl font-bold text-white text-center px-4">
          Millions of Happy Marriages
        </h1>
      </div>

      {/* Info Cards Section */}
      <div className="grid md:grid-cols-3 bg-amber-50 gap-6 text-center mb-10 rounded-lg p-4">
        <div className="p-4 rounded hover:bg-amber-100 transition">
          <Users className="mx-auto text-amber-600 w-10 h-10 mb-3" />
          <p className="text-sm">
            Join millions who have found their life partner through our platform
            and community.
          </p>
        </div>
        <div className="p-4 rounded hover:bg-amber-100 transition">
          <Star className="mx-auto text-amber-600 w-10 h-10 mb-3" />
          <p className="text-sm">
            We are featured in the Limca Book of Records for the highest number
            of documented marriages online.
          </p>
        </div>
        <div className="p-4 rounded hover:bg-amber-100 transition">
          <Heart className="mx-auto text-amber-600 w-10 h-10 mb-3" />
          <p className="text-sm">
            We help more people find love and companionship than any other
            matrimony service globally.
          </p>
        </div>
      </div>

      {/* Recent Success Stories Section */}
      <h2 className="text-2xl font-bold mb-4">Recent Success Stories</h2>
      {loading ? (
        <p>Loading stories...</p>
      ) : (
        <div
          className={`grid gap-6 ${
            stories.length === 1
              ? "grid-cols-1"
              : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
          }`}
        >
          {stories.length === 0 ? (
            <p>No stories available at the moment.</p>
          ) : (
            stories.map((story) => (
              <div
                key={story.id}
                className="flex bg-white rounded shadow p-4 gap-4 hover:shadow-lg transition"
              >
                {story.photo ? (
                  <img
                    src={story.photo}
                    alt={`${story.bride_name} & ${story.groom_name}`}
                    className="w-32 h-32 object-cover rounded"
                  />
                ) : (
                  <div className="w-32 h-32 bg-gray-200 rounded flex items-center justify-center text-gray-500">
                    No Image
                  </div>
                )}
                <div>
                  <h3 className="font-semibold text-lg">
                    {story.bride_name} & {story.groom_name}
                  </h3>
                  <p className="text-sm text-gray-500 mb-2">
                    Posted on: {new Date(story.created_at).toLocaleDateString()}
                  </p>
                  <p className="text-gray-700 text-sm line-clamp-3">
                    {story.story.slice(0, 100)}...
                  </p>
                  <Link
                    to={`/success-stories/${story.id}`}
                    className="text-orange-600 text-sm mt-1 inline-block hover:underline"
                  >
                    Read more...
                  </Link>
                </div>
              </div>
            ))
          )}
        </div>
      )}

      {/* View All Button */}
      {/* <div className="text-center mt-10">
        <Link
          to="/success-stories/all"
          className="inline-block px-6 py-2 border border-orange-600 text-orange-600 rounded-full hover:bg-orange-600 hover:text-white transition"
        >
          View all success stories →
        </Link>
      </div> */}
    </div>
  );
};

export default SuccessStoriesPage;
